// @ts-ignore
import ApiClient from '../api-client/apiClient';
// @ts-ignore
import { PORT, apiUrl, version } from '../environment';
// @ts-ignore
import { getAccessToken } from '../auth';


import { notification } from 'antd';
import { handleIsLoading, handleLoading } from '@store/general';
import {
    businessCategoryList,
    businessDefaultFailed,
    businessDefaultSuccess,
    businessDetailsFailed, businessDtailsSuccess, businessGetFailed,
    businessGetSuccess, businessReferUsgetFailed, businessReferUsgetSuccess, getContactUsFailed, getContactUsSuccess, rewardListFailed,
    rewardListSuccess
} from '@store/Business/business';
import { checkuser } from './user';
type NotificationType = 'success' | 'info' | 'warning' | 'error';

export function openNotificationWithIcon(type: NotificationType, message: string) {
    notification[type]({
        message: message,
        placement: 'topRight', // You can change the placement if needed
    });
}

// *********** bussiness Details **********************
export const businessDetailsAction = (data: any, callback: any) => {
    return (dispatch: any) => {
        dispatch(handleIsLoading(true));
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        ApiClient.get(`${apiUrl}${PORT}${version}/admin/business-details`, data, token, dispatch).then(
            (response: any) => {
                // dispatch({ type: 'ISLOADING', data: false });
                if (response.status === 200 || response.status === 201) {
                    dispatch(businessDtailsSuccess(response.data));
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else if (response.status === 404) {
                    dispatch(businessDetailsFailed(response.data));
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else {
                    // openNotificationWithIcon('error', response.message);
                    dispatch(handleIsLoading(false));
                    return callback(response);
                }
            }
        );
    };
};

// *********** get all bussiness categories **********************
export const getAllBusinessCategories = (data: any, callback: any) => {
    return (dispatch: any) => {
        dispatch(handleIsLoading(true));
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        ApiClient.get(`${apiUrl}${PORT}${version}/admin/get-all-business-category`, {}, token, dispatch).then(
            (response: any) => {
                if (response.status === 200 || response.status === 201) {
                    dispatch(businessCategoryList(response.data));
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else if (response.status === 404) {
                    dispatch(businessCategoryList(response.data));
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else {
                    dispatch(handleIsLoading(false));
                    return callback(response);
                }
            }
        );
    };
};
// *********** add bussiness categories **********************
export const addBusinessCategories = (data: any, callback: any) => {
    return (dispatch: any) => {
        dispatch(handleIsLoading(true));
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        ApiClient.post(`${apiUrl}${PORT}${version}/super-admin/addBusinessCategory`, data, token, dispatch).then(
            (response: any) => {
                if (response.status === 200 || response.status === 201) {
                    dispatch(businessCategoryList(response.data));
                    dispatch(handleIsLoading(false));
                    openNotificationWithIcon('success', response.message);
                    return callback(response);
                } else if (response.status === 404) {
                    dispatch(businessCategoryList(response.data));
                    dispatch(handleIsLoading(false));
                    openNotificationWithIcon('error', response.message);
                    return callback(response);
                } else {
                    openNotificationWithIcon('error', response.message);
                    dispatch(handleIsLoading(false));
                    return callback(response);
                }
            }
        );
    };
};
// *********** update bussiness categories **********************
export const updateBusinessCategories = (data: any, callback: any) => {
    return (dispatch: any) => {
        dispatch(handleIsLoading(true));
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        ApiClient.patch(`${apiUrl}${PORT}${version}/super-admin/updateBusinessCategory/${data?.id}`, data, token, dispatch).then(
            (response: any) => {
                if (response.status === 200 || response.status === 201) {
                    dispatch(businessCategoryList(response.data));
                    dispatch(handleIsLoading(false));
                    openNotificationWithIcon('success', response.message);
                    return callback(response);
                } else if (response.status === 404) {
                    dispatch(businessCategoryList(response.data));
                    dispatch(handleIsLoading(false));
                    openNotificationWithIcon('error', response.message);
                    return callback(response);
                } else {
                    openNotificationWithIcon('error', response.message);
                    dispatch(handleIsLoading(false));
                    return callback(response);
                }
            }
        );
    };
};

// *********** delete bussiness categories **********************
export const deleteBusinessCategories = (data: any, callback: any) => {
    return (dispatch: any) => {
        dispatch(handleIsLoading(true));
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        ApiClient.delete(`${apiUrl}${PORT}${version}/super-admin/deleteBusinessCategory/${data?.id}`, token, dispatch).then(
            (response: any) => {
                if (response.status === 200 || response.status === 201) {
                    dispatch(businessCategoryList(response.data));
                    dispatch(handleIsLoading(false));
                    openNotificationWithIcon('success', response.message);
                    return callback(response);
                } else if (response.status === 404) {
                    dispatch(businessCategoryList(response.data));
                    dispatch(handleIsLoading(false));
                    openNotificationWithIcon('error', response.message);
                    return callback(response);
                } else {
                    openNotificationWithIcon('error', response.message);
                    dispatch(handleIsLoading(false));
                    return callback(response);
                }
            }
        );
    };
};

export const businessDetailsById = (data: any, callback: any) => {
    return (dispatch: any) => {
        dispatch(handleIsLoading(true));
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        ApiClient.get(`${apiUrl}${PORT}${version}/super-admin/getBusiness-detailsById/${data}`, {}, token, dispatch).then(
            (response: any) => {
                // dispatch({ type: 'ISLOADING', data: false });
                if (response.status === 200 || response.status === 201) {
                    dispatch(businessDtailsSuccess(response.data));
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else if (response.status === 404) {
                    dispatch(businessDetailsFailed(response.data));
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else {
                    // openNotificationWithIcon('error', response.message);
                    dispatch(handleIsLoading(false));
                    return callback(response);
                }
            }
        );
    };
};

export const updateBusinessDetailsBySuperAdmin = (id: any, data: any, callback: any) => {
    return (dispatch: any) => {
        dispatch(handleIsLoading(true));

        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;

        ApiClient.put(
            `${apiUrl}${PORT}${version}/super-admin/updateBusiness-details/${id}`,
            data,
            token,
            dispatch
        ).then((response: any) => {

            if (response.status === 200 || response.status === 201) {

                dispatch(handleIsLoading(false));

                return callback(response);

            } else if (response.status === 400 || response.status === 404) {

                dispatch(handleIsLoading(false));

                return callback(response);

            } else {

                dispatch(handleIsLoading(false));

                return callback(response);

            }
        });
    };
};


// *********** bussiness Details **********************
export const businessDefaultBisnessAction = (data: any, callback: any) => {
    return (dispatch: any) => {
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        ApiClient.post(`${apiUrl}${PORT}${version}/admin/business-details`, data, token, dispatch).then(
            (response: any) => {
                if (response.status === 200 || response.status === 201) {
                    dispatch(businessDefaultSuccess(response.data));
                    dispatch(handleLoading(false));
                    return callback(response);
                } else if (response.status === 404) {
                    dispatch(businessDefaultFailed(response.data));
                    dispatch(handleLoading(false));
                    return callback(response);
                } else {
                    dispatch(handleLoading(false));
                    return callback(response);
                }
            }
        );
    };
};


// *********** bussiness Details **********************
export const getAllBusinesses = (data: any, callback: any) => {
    return (dispatch: any) => {
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        const { role } = data;
        const adminRoute = role === 1 ? "super-admin" : "admin";
        delete data.role;
        dispatch(handleIsLoading(true))
        ApiClient.get(
            `${apiUrl}${PORT}${version}/${adminRoute}/business-list`,
            data,
            token,
            dispatch
        ).then(
            (response: any) => {
                if (response.status === 200 || response.status === 201) {
                    dispatch(businessGetSuccess(response));
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else if (response.status === 404) {
                    dispatch(businessGetFailed(response.data));
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else {
                    dispatch(businessGetFailed(response.data));
                    dispatch(handleIsLoading(false));
                }
            }
        );
    };
};


// *********** Export bussiness Details **********************
export const exportBusinessAction = (data: any, callback: any) => {
    return (dispatch: any) => {
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        const { role } = data;
        const adminRoute = role === 1 ? "super-admin" : "admin";
        delete data.role;
        dispatch(handleIsLoading(true))
        ApiClient.getFile(
            `${apiUrl}${PORT}${version}/${adminRoute}/export-business`,
            data,
            token,
            dispatch
        ).then(
            (response: any) => {
                if (response.status === 200 || response.status === 201) {
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else if (response.status === 404) {
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else {
                    dispatch(handleIsLoading(false));
                }
            }
        );
    };
};

// *********** Delete business **********************
export const deleteBusinessAction = (data: any, callback: any) => {
    return (dispatch: any) => {
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        dispatch(handleIsLoading(true))
        ApiClient.delete(
            `${apiUrl}${PORT}${version}/super-admin/delete-admins/${data?.id}`,
            token,
            dispatch
        ).then(
            (response: any) => {
                if (response.status === 200 || response.status === 201) {
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else if (response.status === 404) {
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else {
                    dispatch(handleIsLoading(false));
                }
            }
        );
    };
};

// ********************** Delete super admin referrers ******************* //
export const deleteSuperAdminReferrerAction = (data: any, callback: any) => {
    return (dispatch: any) => {
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        dispatch(handleIsLoading(true))
        ApiClient.delete(
            `${apiUrl}${PORT}${version}/super-admin/delete-referus-referrers/${data?.id}`,
            token,
            dispatch
        ).then(
            (response: any) => {
                if (response.status === 200 || response.status === 201) {
                    dispatch(handleIsLoading(false));
                    openNotificationWithIcon('success', response.message);
                    return callback(response);
                } else if (response.status === 404) {
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else {
                    openNotificationWithIcon('error', response.message);
                    dispatch(handleIsLoading(false));
                }
            }
        );
    };
};

// ********************** Delete business referrers ******************* //
export const deleteBusinessReferrerAction = (data: any, callback: any) => {
    return (dispatch: any) => {
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        dispatch(handleIsLoading(true))
        ApiClient.delete(
            `${apiUrl}${PORT}${version}/admin/delete-referrer/${data?.id}`,
            token,
            dispatch
        ).then(
            (response: any) => {
                if (response.status === 200 || response.status === 201) {
                    dispatch(handleIsLoading(false));
                    openNotificationWithIcon('success', response.message);
                    return callback(response);
                } else if (response.status === 404) {
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else {
                    openNotificationWithIcon('error', response.message);
                    dispatch(handleIsLoading(false));
                }
            }
        );
    };
};

// *********** bussiness refer us network **********************
export const getReferUsNetworkBusinesses = (data: any, callback: any) => {
    return (dispatch: any) => {
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        // const { role } = data;
        delete data.role;
        delete data.admin_id;
        dispatch(handleIsLoading(true))
        // const adminRoute = role === 1 ? "super-admin" : "admin";
        ApiClient.get(
            `${apiUrl}${PORT}${version}/admin/referus-network`,
            data,
            token,
            dispatch
        ).then(
            (response: any) => {
                if (response.status === 200 || response.status === 201) {
                    dispatch(businessReferUsgetSuccess(response));
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else if (response.status === 404) {
                    dispatch(businessReferUsgetFailed(response.data));
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else {
                    dispatch(businessReferUsgetFailed(response.data));
                    dispatch(handleIsLoading(false));
                }
            }
        );
    };
};



// *********** Rewards List **********************
export const getAllRewards = (data: any, callback: any) => {
    return (dispatch: any) => {
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        const { role } = data;
        const adminRoute = role === 1 ? "super-admin" : "admin";
        dispatch(handleIsLoading(true))
        ApiClient.get(
            `${apiUrl}${PORT}${version}/${adminRoute}/reward`,
            {},
            token,
            dispatch
        ).then(
            (response: any) => {
                if (response.status === 200 || response.status === 201) {
                    dispatch(rewardListSuccess(response.data));
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else if (response.status === 404) {
                    dispatch(rewardListFailed(response.data));
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else {
                    dispatch(businessGetFailed(response.data));
                    dispatch(handleIsLoading(false));
                }
            }
        );
    };
};

// *********** Rewards List on check **********************
export const getAllRewardWithConditions = (data: any, callback: any) => {
    return (dispatch: any) => {
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        const { role } = data;
        const adminRoute = role === 1 ? "super-admin" : "admin";
        dispatch(handleIsLoading(true))
        ApiClient.get(
            `${apiUrl}${PORT}${version}/${adminRoute}/reward`,
            {},
            token,
            dispatch
        ).then(
            (response: any) => {
                if (response.status === 200 || response.status === 201) {
                    dispatch(rewardListSuccess(response.data));
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else if (response.status === 404) {
                    dispatch(rewardListFailed(response.data));
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else {
                    dispatch(businessGetFailed(response.data));
                    dispatch(handleIsLoading(false));
                }
            }
        );
    };
};

// *********** Rewards List **********************
export const addRewards = (data: any, callback: any) => {
    return (dispatch: any) => {
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        const { role } = data;
        const adminRoute = role === 1 ? "super-admin" : "admin";
        // dispatch(handleLoading(true));
        ApiClient.post(
            `${apiUrl}${PORT}${version}/${adminRoute}/reward`,
            data,
            token,
            dispatch
        ).then(
            (response: any) => {
                if (response.status === 200 || response.status === 201) {
                    dispatch(handleLoading(false));
                    openNotificationWithIcon('success', response?.message)
                    return callback(response);
                } else if (response.status === 404) {
                    // dispatch(rewardListFailed(response.data));
                    dispatch(handleLoading(false));
                    openNotificationWithIcon('error', response?.message)
                    return callback(response);
                } else {
                    dispatch(businessGetFailed(response.data));
                    openNotificationWithIcon('error', response?.message)
                    dispatch(handleLoading(false));
                }
            }
        );
    };
};
// *********** Rewards List **********************
export const deleteRewards = (data: any, callback: any) => {
    return (dispatch: any) => {
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        const { role } = data;
        const adminRoute = role === 1 ? "super-admin" : "admin";
        // dispatch(handleLoading(true));
        ApiClient.delete(
            `${apiUrl}${PORT}${version}/${adminRoute}/reward/${data?.id}`,
            token,
            dispatch
        ).then(
            (response: any) => {
                if (response.status === 200 || response.status === 201) {
                    // dispatch(rewardListSuccess(response.data));
                    dispatch(handleLoading(false));
                    openNotificationWithIcon('success', response?.message)
                    dispatch(getAllRewards(data, () => { }))
                    return callback(response);
                } else if (response.status === 404) {
                    // dispatch(rewardListFailed(response.data));
                    dispatch(handleLoading(false));
                    openNotificationWithIcon('error', response?.message)
                    return callback(response);
                } else {
                    dispatch(businessGetFailed(response.data));
                    openNotificationWithIcon('error', response?.message)
                    dispatch(handleLoading(false));
                }
            }
        );
    };
};

// *********** Rewards List **********************
export const updateRewards = (data: any, callback: any) => {
    return (dispatch: any) => {
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        const { role } = data;
        const adminRoute = role === 1 ? "super-admin" : "admin";
        let payload = {...data};
        delete payload.id;
        dispatch(handleIsLoading(true))
        ApiClient.patch(
            `${apiUrl}${PORT}${version}/${adminRoute}/reward/${data?.id}`,
            payload,
            token,
            dispatch
        ).then(
            (response: any) => {
                if (response.status === 200 || response.status === 201) {
                    dispatch(rewardListSuccess(response.data));
                    dispatch(handleIsLoading(false));
                    openNotificationWithIcon('success', response?.message)
                    return callback(response);
                } else if (response.status === 404) {
                    dispatch(rewardListFailed(response.data));
                    dispatch(handleIsLoading(false));
                    openNotificationWithIcon('error', response?.message)
                    return callback(response);
                } else {
                    dispatch(businessGetFailed(response.data));
                    openNotificationWithIcon('error', response?.message)
                    dispatch(handleIsLoading(false));
                }
            }
        );
    };
};

// *********** Update Business Login Status **********************
export const updateBusinessStatus = (data: any, callback: any) => {
    return (dispatch: any) => {
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        ApiClient.patch(
            `${apiUrl}${PORT}${version}/super-admin/update-status`,
            data,
            token,
            dispatch
        ).then(
            (response: any) => {
                if (response.status === 200 || response.status === 201) {
                    // dispatch(rewardListSuccess(response.data));
                    dispatch(handleLoading(false));
                    openNotificationWithIcon('success', response?.message)
                    return callback(response);
                } else if (response.status === 404) {
                    // dispatch(rewardListFailed(response.data));
                    dispatch(handleLoading(false));
                    openNotificationWithIcon('error', response?.message)
                    return callback(response);
                } else {
                    dispatch(handleLoading(false));
                    openNotificationWithIcon('error', response?.message)
                }
            }
        );
    };
};


// *********** Contact Us List **********************
export const getContactUs = (data: any, callback: any) => {
    return (dispatch: any) => {
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        dispatch(handleIsLoading(true))
        ApiClient.get(
            `${apiUrl}${PORT}${version}/super-admin/getContactUs`,
            data,
            token,
            dispatch
        ).then(
            (response: any) => {
                if (response.status === 200 || response.status === 201) {
                    dispatch(getContactUsSuccess(response.data));
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else if (response.status === 404) {
                    dispatch(getContactUsFailed(response.data));
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else {
                    dispatch(getContactUsFailed(response.data));
                    dispatch(handleIsLoading(false));
                }
            }
        );
    };
};

// *********** Update Contact Status **********************
export const updateContactStatus = (data: any, callback: any) => {
    return (dispatch: any) => {
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        dispatch(handleIsLoading(true))
        ApiClient.patch(
            `${apiUrl}${PORT}${version}/super-admin/update-ticket-status`,
            data,
            token,
            dispatch
        ).then(
            (response: any) => {
                if (response.status === 200 || response.status === 201) {
                    // dispatch(rewardListSuccess(response.data));
                    dispatch(handleIsLoading(false));
                    openNotificationWithIcon('success', response?.message)
                    return callback(response);
                } else if (response.status === 404) {
                    // dispatch(rewardListFailed(response.data));
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else {
                    dispatch(handleIsLoading(false));
                }
            }
        );
    };
};

// *********** Add Tickets **********************
export const addTicket = (data: any, callback: any) => {
    return (dispatch: any) => {
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        // dispatch(handleLoading(true));
        ApiClient.post(
            `${apiUrl}${PORT}${version}/contactUs/raise-ticket`,
            data,
            token,
            dispatch
        ).then(
            (response: any) => {
                if (response.status === 200 || response.status === 201) {
                    dispatch(handleLoading(false));
                    openNotificationWithIcon('success', response?.message)
                    return callback(response);
                } else if (response.status === 404) {
                    dispatch(handleLoading(false));
                    openNotificationWithIcon('error', response?.message)
                    return callback(response);
                } else {
                    dispatch(businessGetFailed(response.data));
                    openNotificationWithIcon('error', response?.message)
                    dispatch(handleLoading(false));
                }
            }
        );
    };
};


/**
 * ************** Super admin sms actions  ****************************** /
 */

// *********** get all sms templates **********************
export const getAllSmsTemplates = (data: any, callback: any) => {
    return (dispatch: any) => {
        dispatch(handleIsLoading(true))
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        const adminRoute = "super-admin";
        delete data.role;
        ApiClient.get(
            `${apiUrl}${PORT}${version}/${adminRoute}/getSmsTemplates`,
            data,
            token,
            dispatch
        ).then(
            (response: any) => {
                if (response.status === 200 || response.status === 201) {
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else if (response.status === 404) {
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else {
                    dispatch(handleIsLoading(false));
                }
            }
        );
    };
};

// *********** update Sms Template **********************
export const getSmsTemplate = (data: any, callback: any) => {
    return (dispatch: any) => {
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        const adminRoute = "super-admin";
        dispatch(handleIsLoading(true))
        ApiClient.get(
            `${apiUrl}${PORT}${version}/${adminRoute}/get-sms-template`,
            data,
            token,
            dispatch
        ).then(
            (response: any) => {
                if (response.status === 200 || response.status === 201) {
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else if (response.status === 404) {
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else {
                    dispatch(handleIsLoading(false));
                }
            }
        );
    };
}

// *********** Add Sms Template **********************
export const addSmsTemplate = (data: any, callback: any) => {
    return (dispatch: any) => {
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        const adminRoute = "super-admin";
        delete data.role;
        dispatch(handleIsLoading(true))
        ApiClient.post(
            `${apiUrl}${PORT}${version}/${adminRoute}/add-sms-template`,
            data,
            token,
            dispatch
        ).then(
            (response: any) => {
                if (response.status === 200 || response.status === 201) {
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else if (response.status === 404) {
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else {
                    dispatch(handleIsLoading(false));
                }
            }
        );
    };
}


// *********** update Sms Template **********************
export const updateSmsTemplate = (data: any, callback: any) => {
    return (dispatch: any) => {
        const tokenRaw: any = getAccessToken();
        const token = `Bearer ${tokenRaw}`;
        const adminRoute = "super-admin";
        delete data.role;
        dispatch(handleIsLoading(true))
        ApiClient.put(
            `${apiUrl}${PORT}${version}/${adminRoute}/update-sms-template`,
            data,
            token,
            dispatch
        ).then(
            (response: any) => {
                if (response.status === 200 || response.status === 201) {
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else if (response.status === 404) {
                    dispatch(handleIsLoading(false));
                    return callback(response);
                } else {
                    dispatch(handleIsLoading(false));
                }
            }
        );
    };
}

export const connectMindbodyAction = (data: any, callback: any) => {
  return (dispatch: any) => {
    const token = `Bearer ${getAccessToken()}`;

    ApiClient.get(
      `${apiUrl}${PORT}${version}/admin/mindbody/connect`,
      data,
      token,
      dispatch
    ).then((response: any) => {
        if (response.status === 200 || response.status === 201) {
          openNotificationWithIcon("success",
            response?.message || "Mindbody connection initiated"
          );
        } else {
          openNotificationWithIcon(
            "error",
            response?.message || "Something went wrong"
          );
        }

        return callback(response);
      })
      .catch((error: any) => {
        openNotificationWithIcon(
          "error",
          error?.response?.data?.message || "API Error"
        );

        return callback(error?.response || error);
      });
  };
};

export const verifyMindbodyAction = (siteId: string, callback?: any) => {
  return async (dispatch: any) => {
    try {
      const token = `Bearer ${getAccessToken()}`;

      const response = await ApiClient.post(
        `${apiUrl}${PORT}${version}/admin/mindbody/verify`,
        { siteId },
        token,
        dispatch
      );

      if (response?.status === 200) {
        openNotificationWithIcon("success", "Mindbody connected successfully");

        // refresh user
        dispatch(checkuser(() => {}));

        callback && callback({ success: true });

      } else {
        openNotificationWithIcon("error", response?.message);
        callback && callback({ success: false });
      }

    } catch (error: any) {
      openNotificationWithIcon(
        "error",
        error?.response?.data?.message ||
          "Please complete authorization first."
      );

      callback && callback({ success: false });
    }
  };
};

export const getMindbodyTokenAction = (data: any, callback: any) => {
  return (dispatch: any) => {
    const tokenRaw: any = getAccessToken();
    const token = `Bearer ${tokenRaw}`;

    dispatch(handleLoading(true));

    ApiClient.post(
      `${apiUrl}${PORT}${version}/admin/mindbody/token`,
      data,
      token,
      dispatch
    ).then((response: any) => {
      if (response.status === 200 || response.status === 201) {
        dispatch(handleLoading(false));

        // optional success toast
        // openNotificationWithIcon('success', response?.message)

        return callback(response);

      } else if (response.status === 404) {
        dispatch(handleLoading(false));
        openNotificationWithIcon('error', response?.message);
        return callback(response);

      } else {
        dispatch(handleLoading(false));
        openNotificationWithIcon('error', response?.message);
      }
    });
  };
};